<template>
<div class="IssueCommandContainer">
  <div class="nowData commonCons">
    <div class="cons">
      <h3>命令</h3>
    </div>
    <div class="cardBanner">
      <ul :style="{marginLeft:commandTabs.length*(-50)+'px'}">
        <li v-for="(item,index) in commandTabs" :key="index" @click="commandClick(item)">
          <div class="titName">
            <span>{{item.name}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="hositoryData commonCons">
    <div class="cons">
      <h3>记录</h3>
    </div>
    <div class="listCons">
      <div class="query">
        <span class="qCons">
          <el-date-picker :disabled="false" v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
          <el-select v-model="keyWords.command" placeholder="下发命令" style="padding: 5px 0" clearable>
            <!-- <el-option label="复位" value="reset"></el-option> -->
            <el-option label="消音" value="silencer"></el-option>
            <!-- <el-option label="手动报警" value="alarm"></el-option>
            <el-option label="自检" value="check"></el-option> -->
          </el-select>
          <el-select v-model="keyWords.success" placeholder="下发结果" style="padding: 5px 0" clearable>
            <el-option label="成功" :value="true"></el-option>
            <el-option label="失败" :value="false"></el-option>
          </el-select>
          <button :style="styleObj" class="primaryBtn" @click="searchData">查询</button>
        </span>
      </div>
      <div class="dataCons">
        <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="gasCurrentChange" @sizeChange="gasSizeChange">
          <el-table-column type="index" label="#" width="60"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="" label="命令" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div>{{scope.row.command == 'reset'? '复位' : scope.row.command == 'silencer'? '消音' : scope.row.command == 'alarm'? '手动报警' : '自检'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="失败信息" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createTime" label="下发时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="" label="下发结果" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span :style="{color : scope.row.success ? '#00b050' : '#ff0000'}" :disabled="scope.row.success">{{scope.row.success ? '成功' : '失败'}}</span>
            </template>
          </el-table-column>
        </border-table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/views/deviceManagement/deviceSmoke/BorderTableNew";
export default {
  components: {
    BorderTable
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      keyWords: {
        command:'',
        success:''
      },
      pickerOptionsDate:{
        disabledDate(time) {
          // 禁止选择本日之后
          return (time.getTime() > Date.now()) || ((time.getTime() + 3600 * 1000 * 24 * 30) < Date.now());
        },
      },
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchText: '',
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
      dataList: [],
      deviceTypeList: [],
      num:0,
      activeIndex:0,
      deviceDatas:{},
      consShow:false,
      datetime:'',
      timer: null,
      styleObj:{},
      commandTabs:[
        // {
        //   name:'复位',
        //   value:'reset'
        // },
        {
          name:'消音',
          value:'silencer'
        }
        // ,{
        //   name:'手动报警',
        //   value:'alarm'
        // }
        // ,{
        //   name:'自检',
        //   value:'check'
        // }
      ]
    }
  },
  created() {
    let nowTime = new Date()
    let lastTime = new Date(nowTime.getTime() - 3600 * 1000 * 24 * 30)
    this.creatTime = [lastTime, nowTime]
    this.reloadTable();
  },
  methods: {
    searchData() {
      if(!this.creatTime||this.creatTime.length<1){
        this.msg.warn('请您选择日期！')
        return
      }
      //查询//查询
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    gasCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    gasSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    getCurrentYear() {
      this.consShow=false
      // console.log(this.creatTime);
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          this.params = {
            "key": this.searchText,
            "startTime": this.fbdate,
            "endTime": this.fedate,
            "page": this.pagination.currentPage,
            "pageSize": this.pagination.pageSize,
            "sort": "createTime",
            "order": "desc",
            "deviceId": this.deviceId,
            "command":this.keyWords.command,
            "success":this.keyWords.success
          }
          this.request.get("/front/device/command/record", this.params).then(res => {
            this.consShow=true
            if (res.code == 200) {
              console.log(res);
              this.tableLoading = false
              this.dataList = res.data;
              this.pagination.total = res.total;
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
              // this.msg.warn("查询月份的报警分表不存在")
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        // this.msg.warn("请选择开始日期和结束日期！")
        this.params = {
          "key": this.searchText,
          "startTime": '',
          "endTime": '',
          "page": this.pagination.currentPage,
          "pageSize": this.pagination.pageSize,
          "sort": "createTime",
          "order": "desc",
          "deviceId": this.deviceId,
          "command":this.keyWords.command,
          "success":this.keyWords.success
        }
        this.request.get("/front/device/command/record", this.params).then(res => {
          this.consShow=true
          if (res.code == 200) {
            this.tableLoading = false
            this.dataList = res.data;
            this.pagination.total = res.total;
          } else if (res.code == 500) {
            // this.msg.warn("查询月份的报警分表不存在")
            this.msg.warn(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    reloadTable() {
      this.getCurrentYear()
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //下发命令
    commandClick(data){
      console.log(data);
      // this.dataList = []
      this.request.post("/front/device/smoke/"+this.deviceId+"/"+data.value).then(res => {
        if (res.code == 200) {
          // console.log(res);
          this.msg.success("下发命令成功！")
        } else if (res.code == 500) {
          this.msg.warn(res.msg)
        }
        let nowTime = new Date()
        let lastTime = new Date(nowTime.getTime() - 3600 * 1000 * 24 * 30)
        let nowTimes = new Date(nowTime.getTime()+60*1000)
        this.creatTime = [lastTime, nowTimes]
        this.reloadTable();
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.IssueCommandContainer {
  width: 100%;
  height: 100%;

  .commonCons {
    width: 100%;

    .cons {
      width: 100%;
      height: 36px;
      background: #F4F7FA;
      border-radius: 2px;
      position: relative;
      h3 {
        width: 100%;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #33383E;
      }
    }
    .listCons{
      .query{
        margin-top: 15px;
        overflow: hidden;
        .qCons{
          float: left;
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover{
            background: #0774e0;
          }
        }
      }
    }
  }

  .nowData {}

  .hositoryData {}

  .cardBanner {
    padding: 10px 30px;
    background-color: #fff;
    position: relative;
    height: 110px;
    ul{
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -18px;
      // margin-left: -204px;
      li{
        float: left;
        cursor: pointer;
        padding:0 10px;
        font-size: 14px;
        line-height: 36px;
        box-sizing: border-box;
        background: #FFFFFF;
        &:hover{
          color: #FFFFFF;
          .titName{
            background: #0774e0;
            span{
              color: #fff;
            }
          }
        }
        .titName{
          width: 82px;
          height: 36px;
          text-align: center;
          border-radius: 2px;
          border: 1px solid #1089FF;
          span{
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
            font-weight: 500;
            color: #1089FF;
          }
        }
      }
    }
  }
}
</style><style lang="scss">
.IssueCommandContainer {
  .query {
    padding-bottom: 15px;

    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
    .el-date-editor{
      .el-input__prefix{
        .el-input__icon{
          line-height: 36px;
        }
      }
      .el-input__suffix{
        .el-input__icon{
          line-height: 36px;
        }
      }
    }
  }
  .queryLists{
    .query{
      .el-date-editor{
        width: 150px;
      }
    }
  }

  .el-carousel{
    width: 700px;
    padding-left: 100px;
    margin: 0 auto;
    .el-carousel__item{
      background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
      background-size: 100% 100%;
      opacity: 0.6;
      &.active{
        opacity: 1;
      }
    }
  }

  // .el-carousel__item:nth-child(2n) {
  //   // background-color: #99a9bf;
  //   background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
  //   background-size: 100% 100%;
  // }

  // .el-carousel__item:nth-child(2n+1) {
  //   background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
  //   background-size: 100% 100%;
  //   // background-color: #d3dce6;
  // }

  .el-carousel__item.el-carousel__item--card.is-in-stage {
    width: 200px;
    height: 110px;
    text-align: center;
  }

  /*修改高度*/
  .el-carousel__container {
    height: 110px;
  }
  .el-carousel__indicators{
    display: none;
  }
  .van-collapse-item__content {
    padding: 14px 0;
  }

  /*左右箭头的样式*/
  button.el-carousel__arrow.el-carousel__arrow--left,
  button.el-carousel__arrow.el-carousel__arrow--right {
    font-size: 14px;
    height: 30px;
    width: 30px;
    background: #A099F0;
    display: none;
  }
}
</style>
